import {
  Alert,
  Button,
  Col,
  Container,
  Modal,
  Nav,
  Navbar,
  Offcanvas,
} from "react-bootstrap";
import logo from "../Assets/logo.png";
import { Link, useNavigate } from "react-router-dom";
import React from "react";
import { isMobile } from "react-device-detect";
import { DisableDays } from "../APIs/api-routes.util";
const Hearder = () => {
  const [expand, setExpand] = React.useState(!isMobile);
  const [origin, setOrigin] = React.useState("");
  const [showModal, setShowModal] = React.useState(false);
  const [show, setShow] = React.useState(false);
  const [message, setMessage] = React.useState("");
  const [date, setDate] = React.useState("");
  const [color, setColor] = React.useState("success");

  const navigate = useNavigate();
  const handleConfirm = () => {
    localStorage.clear();
    navigate("/login");
  };
  const handleCloseModal = () => {
    setShowModal(false);
    setExpand(true);
  };
  const handelClick = () => {
    setOrigin("logout");
    setShowModal(true);
  };
  const handelDisable = () => {
    DisableDays(date).subscribe((res: any) => {
      if ("response" in res && res.response?.status === "success") {
        setShow(true);
        setColor("success");
        setMessage("The day you selected wass disabled succesfully");
      } else {
        setShow(true);
        setColor("danger");

        setMessage("SomeThing went wrong");
      }
    });
    setShowModal(false);
  };

  return (
    <div>
      <>
        <Navbar
          expand={expand}
          bg="dark"
          data-bs-theme="dark"
          className=" nav bg-body-tertiary mb-3"
        >
          <Container fluid>
            <Navbar.Brand>
              <img alt="" src={logo} width="30" height="30" />{" "}
              <Link className="no-style" to="/dashboard">
                Admin Dashboard
              </Link>
            </Navbar.Brand>
            <Navbar.Toggle aria-controls={`offcanvasNavbar-expand-${expand}`} />
            <Navbar.Offcanvas
              id={`offcanvasNavbar-expand-${expand}`}
              aria-labelledby={`offcanvasNavbarLabel-expand-${expand}`}
              placement="end"
            >
              <Offcanvas.Header closeButton>
                <Offcanvas.Title id={`offcanvasNavbarLabel-expand-${expand}`}>
                  Actions
                </Offcanvas.Title>
              </Offcanvas.Header>
              <Offcanvas.Body>
                <Nav className={`justify-content-start me-auto flex-grow-1 pe-3 ${isMobile ? 'flex-column' : ''}`}>
                  <Link
                    style={{ 
                      color: isMobile ? "black" : "white",
                      padding: isMobile ? "10px 0" : "0",
                      fontSize: isMobile ? "16px" : "14px",
                      display: "block",
                      textDecoration: "none"
                    }}
                    className="no-style"
                    to="/appointments"
                  >
                    Appointments
                  </Link>

                  <Link
                    style={{ 
                      color: isMobile ? "black" : "white",
                      padding: isMobile ? "10px 0" : "0",
                      fontSize: isMobile ? "16px" : "14px",
                      display: "block",
                      textDecoration: "none"
                    }}
                    className="no-style"
                    to="/admin-booking"
                  >
                    Book New
                  </Link>

                  <Link
                    style={{ 
                      color: isMobile ? "black" : "white",
                      padding: isMobile ? "10px 0" : "0",
                      fontSize: isMobile ? "16px" : "14px",
                      display: "block",
                      textDecoration: "none"
                    }}
                    className="no-style"
                    to="/disable-dates"
                  >
                    Disable days
                  </Link>

                  <Link
                    style={{ 
                      color: isMobile ? "black" : "white",
                      padding: isMobile ? "10px 0" : "0",
                      fontSize: isMobile ? "16px" : "14px",
                      display: "block",
                      textDecoration: "none"
                    }}
                    className="no-style"
                    to="/logs"
                  >
                    Logs
                  </Link>
                </Nav>
                <Col xs="auto" style={{ 
                  display: "flex", 
                  flexDirection: isMobile ? "column" : "row",
                  gap: isMobile ? "10px" : "0px",
                  marginTop: isMobile ? "20px" : "0px"
                }}>
                  <Button
                    style={{
                      fontSize: isMobile ? "14px" : "16px",
                      padding: isMobile ? "8px 12px" : "10px 16px",
                      width: isMobile ? "100%" : "auto"
                    }}
                    onClick={() => {
                      setShowModal(true);
                      setOrigin("closeAppointments");
                    }}
                  >
                    {isMobile ? "Disable Booking" : "Disable Booking"}
                  </Button>
                  <Button 
                    style={{
                      fontSize: isMobile ? "14px" : "16px",
                      padding: isMobile ? "8px 12px" : "10px 16px",
                      width: isMobile ? "100%" : "auto"
                    }}
                    onClick={handelClick}
                  >
                    {isMobile ? "Logout" : "Logout"}
                  </Button>
                </Col>
              </Offcanvas.Body>
            </Navbar.Offcanvas>
          </Container>
        </Navbar>
        <div className="alert-div" style={isMobile ? { width: "95%" }:{ width: "600px" }} >
          <Alert
            show={show}
            onClose={() => setShow(false)}
            dismissible
            variant={color}
          >
            {message}
          </Alert>
        </div>
      </>

      <Modal show={showModal} onHide={handleCloseModal}>
        {origin === "closeAppointments" && (
          <Modal.Header>Close Appointment</Modal.Header>
        )}
        <Modal.Body>
          {origin === "closeAppointments" ? (
            <div className="flex">
              <input
                type="date"
                className="form-control"
                id="dateInput"
                name="dateInput"
                onChange={(e) => {
                  setDate(e.target.value);
                }}
              />{" "}
            </div>
          ) : (
            "Are you sure you want to logout?"
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Cancel
          </Button>
          <Button
            variant="danger"
            onClick={
              origin === "closeAppointments" ? handelDisable : handleConfirm
            }
          >
            {origin === "closeAppointments" ? "Disable Day" : " Logout"}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default Hearder;
